import React, { ReactElement } from "react"
import { Link } from "@wfp/ui"

const AboutHHPage = (): ReactElement => {
  return (
    <div className="p-3 text-justify">
      <h3 className="mb-1">What is the “Household” module?</h3>
      <p>
        “Household” covers different use cases. Here users, mostly Country Office VAM and Monitoring focal points at
        various levels, can manage and submit survey data for corporate and inter-agency processes. Data is served back
        in a harmonized way, with APIs that enable automations (DataViz, SHAPES, HungerMapLive).
      </p>
      <p className="mt-1">
        Data quality controls and management process is designed to support different base exercises, including
        household assessment, process, programme, and outcome monitoring.
      </p>

      <h5 className="mt-3 mb-1">Key guidance:</h5>
      <ul className="mb-1 list-disc list-inside pl-6 leading-6">
        <li>Technical guidance</li>
        <li>Practical guidance</li>
      </ul>

      <p className="mb-1">Step-by-step:</p>
      <ul className="mb-1 list-disc list-inside pl-6 leading-6">
        <li>
          Review available base questionnaire from the Base XLSForm sub-section and identify the one that matches the
          scope of the data collection carried. If none is available, reach out in dedicated channels.
        </li>
        <li>
          Get the questionnaire in XLSForm format which will be used to collect the data. Upload it in the XLSForms
          section. If the same form is used multiple times you don’t have to re-map it and re-upload it.
        </li>
        <li>
          Check the “mapping” action in the sub-section of the XLSForm, map the fields and choices that you need to be
          standardized and included in the Base data outputs.
        </li>
        <li>Upload the survey, either connecting to MoDa or uploading a CSV extract.</li>
      </ul>

      <p className="mt-3 italic">How do I contextualize or adapt my form?</p>
      <p className="mt-1">
        The adaptation of questionnaire forms is highly discouraged, even though often necessary. Expanding the
        questionnaire with non-standard question will result in no available automation on those data points. The main
        recommendation is to test your form and reach out in the Teams channel for support. Some sets of questions
        (modules) might be already available, or your version might inspire the expansion of the available elements in
        the Codebook.
      </p>

      <h5 className="mt-3 mb-1">Key resources and links:</h5>
      <p className="mb-1">
        <b>Teams channel:</b> any communication can be sent in the{" "}
        <Link
          href="https://teams.microsoft.com/l/team/19%3A4ca595f7681f4ffa8a86b7af58832e8d%40thread.skype/conversations?groupId=cbd1e508-c6e8-459d-96b7-6cac3039c42c&tenantId=462ad9ae-d7d9-4206-b874-71b1e079776f"
          target="_blank"
        >
          DataBridges Teams
        </Link>
        , for peer support, flagging issues, exchange practices and receive updates on ongoing developments. Updated
        practical guides are provided in this channel.
      </p>
      <p className="mb-1">
        <b>API access:</b> please send a request in the dedicated Teams channel. This process is not managed entirely in
        APP and is subject to changes.
      </p>
      <p className="mb-1">
        <b>Data consumption libraries:</b> once API access is granted, see{" "}
        <Link href="https://github.com/WFP-VAM/DataBridgesAPI" target="_blank">
          this dedicated python client
        </Link>
        . To ingest this data more easily (in python and Stata) see{" "}
        <Link href="https://github.com/WFP-VAM/DataBridgesKnots" target="_blank">
          this dedicated library
        </Link>
        .
      </p>
    </div>
  )
}

export default AboutHHPage
